export const RECENT_SEARCH_LIST_LIMIT = 5;
export const croppingRatio = 6;
export const outputQuality = 90;
export const outputInterpolation = 'progressive-bilinear';
export const SURCHARGE_ORDINANCE_CODE = 'surchargeOrdinanceCostDescription';
export const RESORT_FEE_CODE = 'resortFeeDescription';
export const DESTINATION_FEE_CODE = 'destinationFeeDescription';
export const MANDATORYFEE_TITLE = 'Surcharge For Ordinance Cost';
export const DAILY_TEXT = 'Daily ';
export const FEEDESCRIPTION1 = 'Includes';
export const FEEDESCRIPTION2 = 'Surcharge for Ordinance Cost';
export const FEEDESCRIPTION_RESORT = 'Resort Fee';
export const FEEDESCRIPTION_DESTINATION = 'Destination Amenity Fee';
export const VIEW_RATE_LABEL = 'View Rates';
export const PARAM_PAGENO = 'pg';
export const descriptionToDisplayOnPropertyCard = 'HOTEL_MARKETING_CAPTION';
